<template>
  <div v-editable="blok" class="image-fluid">
    <img
      :style="imageHeight"
      :src="blok.image && blok.image.filename"
      :alt="blok.image && blok.image.alt"
      class="image"
    />
  </div>
</template>

<script lang="ts" setup>
// TODO: concider removing this component as it only appears once and
// can be replaced with standard image after some tweaks
import type { SbPictureCardImageStoryblok } from '@/types'
interface Props {
  blok: SbPictureCardImageStoryblok
}
const props = defineProps<Props>()

const imageHeight = computed(() => {
  if (props.blok.image_height === '0' || props.blok.image_height === '') {
    return 'height: 100%;'
  }
  return `height: ${props.blok.image_height}px`
})
</script>

<style lang="scss" scoped>
.image-fluid {
  width: 100%;
}

.image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  object-position: top center;
}
</style>
